import dayjs from "dayjs";
import { types } from "mobx-state-tree";
import { withSetPropAction } from "../../_extension/with-set-props";

export const DateRangeFilterStore = types
  .model("PaginationStore", {
    from: types.maybeNull(types.string),
    to: types.maybeNull(types.string),
  })
  .actions(withSetPropAction)
  .views((self) => ({
    get fromAsDayJs() {
      return self.from ? dayjs(self.from) : null;
    },
    get toAsDayJs() {
      return self.to ? dayjs(self.to) : null;
    },
  }));
